import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default function ProductCardSkeleton() {
  const items = 8

  return (
    <ul className="grid w-full grid-cols-2 gap-3 pb-3 md:gap-6 md:pb-4 lg:grid-cols-4">
      {Array.from({ length: items }, (_, index) => (
        <li key={`vitrine-large-skeleton-${index}`} className="w-full">
          <Skeleton className="h-[309px] w-full rounded-2xl md:h-[455px]" />
        </li>
      ))}
    </ul>
  )
}
